export interface PatientSearch {
    "addAll": AddAll,
    "dob": String,
    "firstName": String,
    "lastName": String
}

export interface PatientMPISearch {
    "addAll": AddAll,
    "mpi": String
}

export interface PatientIdentifierSearch {
    "identifierType": string,
    "identifierValue": string
}

export interface PatientByFacilitySearch {
    "facilityNo": String,
    "excludeInactivePatients": AddAll,
    "pageSize": number,
    "pageNumber": number
}

export enum AddAll {
    N = "N",
    Y = "Y"
}
